import React from "react";
import { SearchResults } from "./SearchResults";
import { LoadingState, NoSearchResults } from "./components";
import { CATEGORY_LIMITS, CATEGORY_TITLES, CategoryType } from "./constants";
import Translations from "@translate/components/QuickInsights/SearchOverview";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface SearchOverviewProps {
  stockSearchData: any[];
  cryptoSearchData: any[];
  searchLoading: boolean;
  onViewAll: (category: CategoryType) => void;
  onItemClick: (item: any, category: CategoryType) => void;
}

export const SearchOverview: React.FC<SearchOverviewProps> = ({
  stockSearchData,
  cryptoSearchData,
  searchLoading,
  onViewAll,
  onItemClick,
}) => (
  <div className="flex flex-col gap-6 pb-6">
    {/* 加载状态 */}
    {searchLoading && (
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <div className="h-5 w-20 bg-background_white_overlay5 rounded animate-pulse" />
          <LoadingState count={4} className="grid-cols-1 gap-2" />
        </div>
        <div className="flex flex-col gap-3">
          <div className="h-5 w-20 bg-background_white_overlay5 rounded animate-pulse" />
          <LoadingState count={4} className="grid-cols-1 gap-2" />
        </div>
      </div>
    )}

    {/* Stocks 搜索结果 */}
    {!searchLoading && stockSearchData.length > 0 && (
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <span className="body_medium_s text-content_tertiary font-medium">
            {CATEGORY_TITLES[CategoryType.STOCKS]}
          </span>
        </div>
        <SearchResults
          data={stockSearchData.slice(0, CATEGORY_LIMITS[CategoryType.STOCKS])}
          isLoading={false}
          onItemClick={(item) => onItemClick(item, CategoryType.STOCKS)}
          hasNextPage={false}
        />
        {stockSearchData.length > CATEGORY_LIMITS[CategoryType.STOCKS] && (
          <button
            aria-label="Search Overview"
            data-openreplay-label={`Search Overview Button | ${I18n.t("View all")}`}
            id="btn-search-overview"
            className="body_medium_s text-content_brand_primary text-center cursor-pointer hover:opacity-80 transition-opacity w-fit"
            onClick={() => onViewAll(CategoryType.STOCKS)}
          >
            {I18n.t("View all")}
          </button>
        )}
      </div>
    )}

    {/* Crypto 搜索结果 */}
    {!searchLoading && cryptoSearchData.length > 0 && (
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <span className="body_medium_s text-content_tertiary font-medium">
            {CATEGORY_TITLES[CategoryType.CRYPTO]}
          </span>
        </div>
        <SearchResults
          data={cryptoSearchData.slice(0, CATEGORY_LIMITS[CategoryType.CRYPTO])}
          isLoading={false}
          onItemClick={(item) => onItemClick(item, CategoryType.CRYPTO)}
          hasNextPage={false}
        />
        {cryptoSearchData.length > CATEGORY_LIMITS[CategoryType.CRYPTO] && (
          <button
            aria-label="Search Overview"
            data-openreplay-label={`Search Overview Button | ${I18n.t("View all")}`}
            id="btn-search-overview-2"
            className="body_medium_s text-content_brand_primary text-center cursor-pointer hover:opacity-80 transition-opacity w-fit"
            onClick={() => onViewAll(CategoryType.CRYPTO)}
          >
            {I18n.t("View all")}
          </button>
        )}
      </div>
    )}

    {/* 无搜索结果提示 */}
    {!searchLoading &&
      stockSearchData.length === 0 &&
      cryptoSearchData.length === 0 && <NoSearchResults />}
  </div>
);
